//*Libraries imports
import { z } from "zod";

export const UserSchema = z.object({
  _id: z.string().optional(),
  name: z.string().optional(),
  email: z.string().email().optional().or(z.literal("")),
  status: z.string().optional(),
  role: z.string().optional(),
  phases: z.array(z.string()).optional(),
  enterpriseId: z.string().optional(),
  cpf_cnpj: z.string().optional(),
  postal: z.string().optional(),
  street: z.string().optional(),
  number: z.string().optional(),
  neighborhood: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  whatsapp: z.string().optional(),
  sector: z.string().optional(),
  area: z.string().optional(),
  photoUrl: z.string().optional(),
  createdAt: z.union([z.string(), z.date()]).optional(),
  updatedAt: z.union([z.string(), z.date()]).optional(),
}).catchall(z.any());

export type User = z.infer<typeof UserSchema>;
